<script lang="ts">
	import { Icon } from '@andresot/ui';
	import { openBroadcastLink } from '$utils/broadcastLink';
	let {
		link,
		messageId,
		preview = false
	}: { link: { label: string; url: string }; messageId?: string; preview?: boolean } = $props();
</script>

<button
	class="link-button"
	disabled={preview}
	onclick={(event) => {
		event.stopPropagation();
		if (!preview) openBroadcastLink(link.url, messageId);
	}}
	aria-label={preview ? `Кнопка рассылки: ${link.label}` : link.label}
>
	{link.label}<Icon name="link" size={16} />
</button>

<style>
	.link-button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: var(--spacing-xs);
		width: 100%;
		min-height: var(--size-40);
		padding: var(--spacing-s) var(--spacing-m);
		border-radius: var(--radius-m);
		background: var(--accent-muted);
		color: var(--accent-primary);
		font: var(--text-body);
		font-weight: 600;
	}
	.link-button:hover {
		background: var(--accent-border);
	}
</style>
